import React, { useState } from "react";
import { useNavigate } from "react-router";
import { post } from "../../../Server";

const useSignUp = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const submit = async mobile => {
    setLoading(true);
    const { data } = await post(
      "/registeruser",
      {
        app: true,
        ...form,
        mobile,
      },
      true
    );
    if (data?.user) {
      navigate("/verify-code", { state: { mobile } });
    }
    setLoading(false);
  };
  return {
    loading,
    form,
    submit,
    setForm,
  };
};

export default useSignUp;
